module.exports = __webpack_public_path__ + "img/38.bc1a21fd.jpg";